import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is the typical turnaround time for a video project?',
      answer: 'Turnaround time varies based on project complexity. Simple videos can be completed in 1-2 weeks, while more complex productions may take 3-4 weeks. We provide a detailed timeline during the planning phase and keep you updated throughout the process.'
    },
    {
      question: 'What is included in your video production packages?',
      answer: 'Our packages include pre-production planning, professional filming with cinema-grade equipment, post-production editing, color grading, sound design, motion graphics, and delivery in multiple formats. We also offer revisions to ensure your complete satisfaction.'
    },
    {
      question: 'What equipment do you use for filming?',
      answer: 'We use professional cinema cameras, stabilization equipment, professional lighting, and high-quality audio recording gear. For aerial shots, we utilize licensed drone equipment. All our gear is regularly maintained and updated to ensure the highest quality output.'
    },
    {
      question: 'Do you provide services outside of Long Island?',
      answer: 'While we are based on Long Island and primarily serve the local area, we can travel for projects throughout New York and the tri-state area. Travel fees may apply for locations outside our standard service area.'
    },
    {
      question: 'Can you help with video marketing strategy?',
      answer: 'Absolutely! We offer consultation on video marketing strategy, including platform optimization, content planning, and distribution recommendations. We ensure your videos are not only beautifully produced but also effective for your marketing goals.'
    },
    {
      question: 'What types of businesses do you work with?',
      answer: 'We work with businesses of all sizes across various industries including corporate, real estate, hospitality, healthcare, retail, and professional services. Our experience spans from small local businesses to large corporations.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to know about our video production services
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-semibold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-xl text-[#1E3A8A] transition-transform ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}